import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToolbox = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M503 215l-46-46c-6-6-14-9-22-9h-51V80c0-27-21-48-48-48H176c-27 0-48 21-48 48v80H77c-8 0-16 3-22 9L9 215c-6 6-9 14-9 22v83h128v-16c0-9 7-16 16-16h32c9 0 16 7 16 16v16h128v-16c0-9 7-16 16-16h32c9 0 16 7 16 16v16h128v-83c0-8-3-16-9-22zm-183-55H192V96h128v64zm64 208c0 9-7 16-16 16h-32c-9 0-16-7-16-16v-16H192v16c0 9-7 16-16 16h-32c-9 0-16-7-16-16v-16H0v96c0 18 14 32 32 32h448c18 0 32-14 32-32v-96H384v16z" })
});
export default SvgToolbox;
